import * as scalar from './src/scalar.js';
export { default as F1Field, default as ZqField } from './src/f1field.js';

const Scalar = scalar;

export { Scalar };
